import React from 'react';

function QualificationCard({ title, location, description, date }) {
  return (
    <div className="timeline__item">
      <div className="circle__dot"></div>
      <h3 className="timeline__title">{title}</h3>
      <p className="timeline__text">{description}{location && (<span> - {location}</span>)}
      </p>
      <span className="timeline__date"><i className="uil uil-calender-alt"></i>{date}</span>
    </div>
  );
}

export default QualificationCard;
